import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../hooks/useFetch';
import { fetchServices } from '../../api/api';
import axios from 'axios';

const ContactForm = () => {
    const { t } = useTranslation();
    const { data: services } = useFetch(["Services"], fetchServices);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        service: '',
        subject: '',
        notes: '',
    });

    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState('');

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setErrors((prevState) => ({
            ...prevState,
            [name]: '',
        }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        // Validation
        const validationErrors = {};
        if (!formData.name) validationErrors.name = t('contactPage.form.errors.name');
        if (!formData.email) validationErrors.email = t('contactPage.form.errors.email');
        if (!formData.service) validationErrors.service = t('contactPage.form.errors.service');
        if (!formData.subject) validationErrors.subject = t('contactPage.form.errors.subject');
        if (!formData.notes) validationErrors.notes = t('contactPage.form.errors.notes');

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        // Send data to Formspree
        try {
            setSubmitting(true);
            setMessage('');

            await axios.post('https://formspree.io/f/xrbgarwv', formData);

            setMessage(t('successMessage'));
            setFormData({
                name: '',
                email: '',
                service: '',
                subject: '',
                notes: '',
            });
        } catch (error) {
            setMessage(t('errorMessage'));
            console.error('Error submitting the form:', error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form onSubmit={submitHandler} className="form">
            <div className="row justify-content-center">
                {/* Name Field */}
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="form-field">
                        <input
                            value={formData.name}
                            onChange={changeHandler}
                            type="text"
                            name="name"
                            placeholder={t('contactPage.form.name')}
                        />
                        <p>{errors.name}</p>
                    </div>
                </div>

                {/* Email Field */}
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="form-field">
                        <input
                            value={formData.email}
                            onChange={changeHandler}
                            type="email"
                            name="email"
                            placeholder={t('contactPage.form.email')}
                        />
                        <p>{errors.email}</p>
                    </div>
                </div>

                {/* Service Dropdown */}
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="form-field">
                        <select
                            className="form-control"
                            onChange={changeHandler}
                            value={formData.service}
                            name="service"
                        >
                            <option value="">{t('contactPage.form.service')}</option>
                            {services?.data?.data?.map((service) => (
                                <option key={service.id} value={service?.data?.title}>
                                    {service?.data?.title}
                                </option>
                            ))}
                        </select>
                        <p>{errors.service}</p>
                    </div>
                </div>

                {/* Subject Field */}
                <div className="col-lg-12 col-md-12 col-12">
                    <div className="form-field">
                        <input
                            value={formData.subject}
                            onChange={changeHandler}
                            type="text"
                            name="subject"
                            placeholder={t('contactPage.form.subject')}
                        />
                        <p>{errors.subject}</p>
                    </div>
                </div>

                {/* Notes/Message Field */}
                <div className="col-lg-12">
                    <div className="form-field">
                        <textarea
                            value={formData.notes}
                            onChange={changeHandler}
                            name="notes"
                            placeholder={t('contactPage.form.message')}
                        ></textarea>
                        <p>{errors.notes}</p>
                    </div>
                </div>

                {/* Submit Button */}
                <div className="col-lg-12">
                    <div className="form-submit">
                        <button
                            type="submit"
                            className="theme-btn"
                            disabled={submitting}
                        >
                            {submitting
                                ? t('submittingButton')
                                : t('contactPage.form.sendMessage')}
                        </button>
                    </div>
                </div>
            </div>
            {/* Feedback Message */}
            {message && <p className="form-message">{message}</p>}
        </form>
    );
};

export default ContactForm;
